module.exports = __webpack_public_path__ + "static/media/icon-adult-female.edcf4ac0.svg";